export default {
  products: [],
  missingProductIds: []
}
